export default "__VITE_ASSET__BmRx_j2s__"